// NOTE local Url
// export const baseUrl = "http://localhost:3000/api";
// NOTE develop Url
// export const baseUrl = "https://api.cmacc.in.th/dev/api";
// NOTE staging Url
// export const baseUrl = "https://api.cmacc.in.th/uat/api";
//NOTE production Url CMACC_3
// export const baseUrl = "https://api.cmacc.in.th/6dd28e9b/api";
// export default baseUrl;

const stage = () => {
  const url = window.location.hostname;
  switch (url) {
    case "cmacc.in.th":
      if (window.location.pathname.includes("6dd28e9b")) {
        return "production03";
      }
      if (window.location.pathname.includes("test")) {
        return "uat";
      }
      return null;
    case "uat-cmacc.web.app":
    case "uat-cmacc.firebaseapp.com":
    case "uat.cmacc.in.th":
      return "uat";
    case "dev-cmacc.web.app":
    case "dev-cmacc.firebaseapp.com":
    case "develop.cmacc.in.th":
    case "localhost":
      return "local";
    default:
      return null;
  }
};

const baseUrl = () => {
  switch (stage()) {
    case "production03":
      return "https://api.cmacc.in.th/6dd28e9b/api";
    case "uat":
      return "https://api.cmacc.in.th/uat/api";
    case "dev":
      return "https://api.cmacc.in.th/dev/api";
    case "local":
      return "http://localhost:3000/api";
    default:
      return "http://localhost:3000/api";
  }
};

export default baseUrl();
